import Vue from 'vue';
import Router from 'vue-router';
import Contents from '@/components/Contents';
import Page from '@/components/Page';
import PDF from '@/components/Pdf';

import introduction from '../templates/introduction.tpl.html';
import teachingStatement from '../templates/teaching-statement.tpl.html';
import scholarshipStatement from '../templates/scholarship-statement.tpl.html';
import serviceStatement from '../templates/service-statement.tpl.html';
import recordings from '../templates/recordings.tpl.html';
import publications from '../templates/publications.tpl.html';

Vue.use(Router);

const pages = [
  {
    name: 'Introduction',
    path: '/introduction',
    content: introduction,
  },
  {
    name: 'Curiculum vitae',
    path: '/cv',
    pdfUrl: '/static/ristow-cv.pdf',
  },
  {
    name: 'Statement of Teaching Philosophy and Priorities',
    path: '/teaching-statement',
    content: teachingStatement,
  },
  {
    name: 'Syllabi & Rehearsal Plans',
    path: '/syllabi-etc/:pageNumber?',
    pdfUrl: '/static/syllabi-and-rehearsal-plans.pdf',
  },
  {
    name: 'Handouts & Assignments',
    path: '/handouts/:pageNumber?',
    pdfUrl: '/static/handouts-and-assignments.pdf',
  },
  {
    name: 'Concert Recordings',
    path: '/recordings',
    content: recordings,
  },
  {
    name: 'Concert Programs',
    path: '/programs/:pageNumber?',
    pdfUrl: '/static/programs.pdf',
  },
  {
    name: 'Statement of Scholarly and Artistic Priorities',
    path: '/scholarship-statement',
    content: scholarshipStatement,
  },
  {
    name: 'External Programs',
    path: '/external-programs/:pageNumber?',
    pdfUrl: '/static/external-programs.pdf',
  },
  {
    name: 'Workshop Handouts',
    path: '/workshops/:pageNumber?',
    pdfUrl: '/static/workshop-handouts.pdf',
  },
  {
    name: 'Publications',
    path: '/publications',
    content: publications,
  },
  {
    name: "Dalcroze's Approach to Solfège and Ear Training, JMTP (2014)",
    path: '/dalcroze-solfege',
    pdfUrl: '/static/jmtp-solfege-pedagogy.pdf',
  },
  {
    name: "Review of Urista's Moving Body in the Aural Skills Classroom, T&P (2017)",
    path: '/urista-review',
    pdfUrl: '/static/ristow-review-of-urista.pdf',
  },
  {
    name: 'Screenshots and information about uTheory.com',
    path: '/utheory',
    pdfUrl: '/static/utheory-discussion.pdf',
  },
  {
    name: 'Other',
    path: '/other-docs/:pageNumber?',
    pdfUrl: '/static/other-documents.pdf',
  },
  {
    name: 'Statement of Priorities for Service',
    path: '/service-statement',
    subtitle: 'to the School, Profession and Community',
    content: serviceStatement,
  },
];


function makeRoute(page, index) {
  const route = {
    path: page.path,
    name: page.name,
    subtitle: page.subtitle,
    component: Page,
    props: {
      title: page.name,
      // content: page.content,
    },
  };
  if (index > 0) {
    route.props.prev = pages[index - 1].path;
  }

  if (index < pages.length - 1) {
    route.props.next = pages[index + 1].path;
  }

  if (page.pdfUrl) {
    route.props.pdfUrl = page.pdfUrl + (page.pageNumber ? `#page=${page.pageNumber}` : '');
    route.component = PDF;
  } else {
    route.props.content = page.content;
  }

  return route;
}

const routes = [
  {
    path: '/',
    name: 'Contents',
    component: Contents,
  },
].concat(pages.map(makeRoute));

export default new Router({
  routes,
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
});



// WEBPACK FOOTER //
// ./src/router/index.js